<template>
  <WithCustomSidebar :config="navigation">
    <slot />
  </WithCustomSidebar>
</template>

<script>
import WithCustomSidebar from '@@/layout/Sidebar/WithCustomSidebar';
import EditIcon from '@/assets/icons/edit.svg';
import StatsIcon from '@/assets/icons/stats.svg';
import useAuth from '@/auth';

export default {
  name: 'WithCampaignInternalNav',
  components: {
    WithCustomSidebar,
  },
  computed: {
    navigation() {
      const { user } = useAuth();
      return {
        key: 'basic-ads-sidebar',
        backButton: {
          route: user.isAdvertisementAdmin
            ? 'advertisement-manage-campaigns'
            : 'basic-ads-campaigns-list',
          title: 'ADVERTISEMENT.TITLE',
        },
        items: [
          {
            route: 'basic-ads-campaign-info',
            title: 'ADVERTISEMENT.CAMPAIGN_VIEW.INFO.TITLE',
            icon: EditIcon,
          },
          {
            route: 'basic-ads-campaign-stats-overall',
            title: 'ADVERTISEMENT.CAMPAIGN_VIEW.STATS.TITLE',
            icon: StatsIcon,
          },
        ],
      };
    },
  },
};
</script>
